module.exports = __webpack_public_path__ + "img/maximize-2.8ccdd199.svg";